import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState, useRef, useMemo, useEffect } from 'react';
import { useAddNewassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import useAuth from '../../../../features/hooks/useAuth';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { HeadingWrap, Span, CommonButton } from '../../../../Styles/CommonStyles';
import { useNavigate } from "react-router-dom";
import nameStringFn from '../../../../data/nameStringFn';
import UnivMyAssetComp from '../../Myasset/UnivMyAssetComp';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import FilteredAssetReqFetcher from '../FilteredAssetReqFetcher';

const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const SubmitButton = styled(CommonButton)`
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 15px;
  background-color: #4caf50;
  
  &:hover {
    background-color: #45a049;
  }
`

const SubmitStoreButton = styled(CommonButton)`
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #2196f3;
  
  &:hover {
    background-color: #0b7dda;
  }
`

// Styled components for the big buttons
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 30px 0;
  flex-wrap: wrap;
  gap: 20px;
`

const BigButton = styled.button`
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  min-width: 300px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background-color: #008080;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    background-color: #008080;
  }
  
  &:active {
    transform: translateY(1px);
  }
  
  &:nth-child(2) {
    background-color: #008080;
    
    &:hover {
      background-color: #008080;
    }
  }
`

const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

const BackButton = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #1976d2;

  &:hover {
    text-decoration: underline;
  }
`;

const SummaryContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
`;

const SummaryHeader = styled.h3`
  color: #1976d2;
  margin-bottom: 15px;
`;

const StyledTableContainer = styled(TableContainer)`
  margin-bottom: 20px;
`;

const StyledTableHead = styled(TableHead)`
  background-color: #1976d2;
  
  & th {
    color: white;
    font-weight: bold;
  }
`;

const RemarkContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
`;

const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
`;

const StoreSelectionContainer = styled.div`
  margin-bottom: 20px;
  max-width: 400px;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const UserAssetReturnReq = () => {
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [field, setField] = useState([]);
  const [content, setContent] = useState('');
  const [showOfficeAssets, setShowOfficeAssets] = useState(false);
  const [showIndiAssets, setShowIndiAssets] = useState(false);
  const [remark, setRemark] = useState('');
  const [selectedStore, setSelectedStore] = useState('');
  const navigate = useNavigate();
  const [allData, setAllData] = useState([]);
  const [filters, setFilters] = useState({
    perm_creator_id: [],
    perm_curr_status: []
  });

  // Get logged in user data
  const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth();
  let user_current_office = (useSelector((state) => state.office.off));

  useEffect(() => {
    setFilters({
      perm_creator_id: [id],
      perm_curr_status: ["Pending"]
  });
  }, [user_current_office, selectedStore]);

  // Get store offices data
  const { storeoffices } = useGetStoreOfficesQuery('storeoffices', {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  });

  // Get user call/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  });

  // Add mutation call
  const [addNewRequest, { isLoading: addNewRequestloading }] = useAddNewassetReqMutation();
  console.log(selectedAssets)
  useEffect(() => {
    if (!selectedAssets || !selectedAssets?.length) return
    setField(prev => {
      const newFields = [...prev]
      selectedAssets.forEach(x => {
        const exists = newFields.some(elm => elm.oem_tag === x.oem_tag);
        if (!exists) {
          newFields.push({
            id:x.id,
            oem_tag: x.oem_tag,
            assetName: x.name,
            spec: x.specification,
            pur_date: x.purchase_date,
            wrty_date: x.warrantyexp_date
          })
        }
      })
      return newFields;
    })
  },[selectedAssets])
  console.log(field)
  // All office call
  const {
    data: allofficedata,
    isLoading: allofficeLoad,
  } = useGetofficesQuery('officelist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });
  let tempallofficedata = allofficedata ? Object.values(allofficedata?.entities) : [];
  const officedata = tempallofficedata;

  // Find BO of user office
  let useroffice = officedata?.filter(elm => elm.name === user_current_office);
  let Bo_id = useroffice[0]?.Bo;
  const StoreL1_id = storeoffices ? Object.values(storeoffices)?.find(office => office?.storeoffice === selectedStore)?.roleUsers?.L1ReqApprover_A : "";
  
  
  // Get list of stores
  const stores = useMemo(() => {
    if (storeoffices) {
      return Object.values(storeoffices).map(store => store.storeoffice);
    }
    return [];
  }, [storeoffices]);

  const handleReturnOfficeAssets = () => {
    setShowOfficeAssets(true);
    setShowIndiAssets(false);
    setSelectedStore('');
    setSelectedAssets([]);
  };

  const handleReturnIndividualAssets = () => {
    setShowIndiAssets(true);
    setShowOfficeAssets(false);
    setSelectedStore('');
    setSelectedAssets([]);
  };

  const handleBack = () => {
    setShowOfficeAssets(false);
    setShowIndiAssets(false);
    setSelectedAssets([]);
    setSelectedStore('');
    setRemark('');
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedAssets([]);
  };

  //create a unique Id
  const uniqueReqID = () => {
    const dateString = Date.now().toString(36);
    const emailofuser = getSingleuser && getSingleuser[id]?.email?.slice(0, -8)
    const uid = `${emailofuser}-${dateString}`
    return uid;
  };
  let uniqueReqId = uniqueReqID()
  //****************************************************************************** */
  
  const handleSubmitToBo = async () => {
    if (allData?.requests?.filter(x => (x.req_store === selectedStore && x.req_type === (showIndiAssets ? 'Ind_Asset_Return_Bo' : "Asset_Return_Bo")))?.length) return alert('You have a pending request. Please wait for it to be processed before submitting a new one.')
    const allRequestedAssetIds = allData?.requests.flatMap(doc =>
      doc.assets_requested?.flatMap(a => a.data.map(d => d.id)) || []
    );
    const matchedAssets = selectedAssets.filter(sel =>
      allRequestedAssetIds.includes(sel.id)
    );
    if (matchedAssets.length > 0) {
      const message = matchedAssets
        .map(asset => `• ${asset.name} (${asset.oem_tag})`)
        .join("\n");

      return alert(`Request for following Assets are already submitted and pending :\n${message}`);
    }
    
    if (selectedAssets.length === 0) {
      alert("Please select at least one asset to return");
      return;
    }

    if (!remark.trim()) {
      alert("Please provide a remark for your return request");
      return;
    }

    // Create request data
    let userReqData = {
      uniqueReqId: uniqueReqId,
      req_type: showIndiAssets ? 'Ind_Asset_Return_Bo' : "Asset_Return_Bo",
      req_creator_id: id,
      req_creator_details: `${nameStringFn(getSingleuser?.[id])}-${user_current_office}-${designation[user_current_office]}`,
      req_store: selectedStore,
      assets_requested: [{ time_stamp: new Date(), actionNo:1, data:field }], 
      bo_partial_issue: false,
      bo_assets_issue: [],
      store_partial_issue: false,
      store_assets_issue: [],
      curr_status: 'Pending',
      created_at: new Date(),
      curr_sent_by: id,
      curr_sent_to: Bo_id,
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[Bo_id])}-${user_current_office}-${getSingleuser?.[Bo_id]?.designation?.[user_current_office] || 'Unknown'}`,
      curr_sent_to_tag: 'ureq_created',
      flow_users: [id],
      req_data: [{
        sent_to_tag: "ureq_created",
        Text: remark,
        sent_by: { 
          id: id, 
          name: getSingleuser?.[id]?.name, 
          office: user_current_office, 
          designation: designation[user_current_office], 
          designationSuffix: designationSuffix[user_current_office], 
          numSuffix: numSuffix[user_current_office] 
        },
        sent_to: {
          id: Bo_id,
          name: getSingleuser?.[Bo_id]?.name,
          office: user_current_office,
          designation: getSingleuser?.[Bo_id]?.designation?.[user_current_office] || 'Unknown'
        },
        action: showIndiAssets ? 'New Individual Asset Return Request to BO Created':  'New Asset Return Request to BO Created',
        time_stamp: new Date(),
      }],
      opened: false
    };

    // Here you would implement the API call to submit the return request
    try {
      await addNewRequest(userReqData)
      setContent('')
      navigate('/management/assets/myrequests')
      return alert('Request Forwarded to Your Branch Officer')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  };

  const handleSubmitToStore = async () => {
    
    if (allData?.requests?.filter(x => (x.req_store === selectedStore && x.req_type === (showIndiAssets ? 'IndAsset_Rtrn_Str_Direct' : "Asset_Return_Store_Via_BO")))?.length) return alert('You have a pending request. Please wait for it to be processed before submitting a new one.')
    const allRequestedAssetIds = allData?.requests.flatMap(doc =>
      doc.assets_requested?.flatMap(a => a.data.map(d => d.id)) || []
    );
    const matchedAssets = selectedAssets.filter(sel =>
      allRequestedAssetIds.includes(sel.id)
    );
    if (matchedAssets.length > 0) {
      const message = matchedAssets
        .map(asset => `• ${asset.name} (${asset.oem_tag})`)
        .join("\n");

      return alert(`Request for following Assets are already submitted and pending :\n${message}`);
    }
    
    
      if (selectedAssets.length === 0) {
      alert("Please select at least one asset to return");
      return;
    }

    if (!remark.trim()) {
      alert("Please provide a remark for your return request");
      return;
    }

    // For Office Assets: They go through BO first, not directly to store
    if (showOfficeAssets) {
      // Create request data for Office Assets - goes to BO first
      let userReqData = {
        uniqueReqId: uniqueReqId,
        req_type: "Asset_Return_Store_Via_BO", // Updated type to indicate flow
        req_creator_id: id,
        req_creator_details: `${nameStringFn(getSingleuser?.[id])}-${user_current_office}-${designation[user_current_office]}`,
        req_store: selectedStore,
        assets_requested:[{ time_stamp: new Date(), actionNo:1, data:field }], 
        bo_partial_issue: false,
        bo_assets_issue: [],
        store_partial_issue: false,
        store_assets_issue: [],
        curr_status: 'Pending',
        created_at: new Date(),
        curr_sent_by: id,
        curr_sent_to: Bo_id,
        curr_sent_to_string: `${nameStringFn(getSingleuser?.[Bo_id])}-${user_current_office}-${getSingleuser?.[Bo_id]?.designation?.[user_current_office] || 'Unknown'}`,
        curr_sent_to_tag: 'ureq_rtrn_asst_created',
        flow_users: [id],
        req_data: [{
          sent_to_tag: "ureq_rtrn_asst_created",
          Text: remark,
          sent_by: { 
            id: id, 
            name: getSingleuser?.[id]?.name, 
            office: user_current_office, 
            designation: designation[user_current_office], 
            designationSuffix: designationSuffix[user_current_office], 
            numSuffix: numSuffix[user_current_office] 
          },
          sent_to: {
            id: Bo_id,
            name: getSingleuser?.[Bo_id]?.name,
            office: user_current_office,
            designation: getSingleuser?.[Bo_id]?.designation?.[user_current_office] || 'Unknown'
          },
          action: 'New Office Asset Return Request to Store via BO Created',
          time_stamp: new Date(),
        }],
        opened: false
      };

      // Submit to BO first, similar to handleSubmitToBo
      try {
        await addNewRequest(userReqData)
        setContent('')
        navigate('/management/assets/myrequests')
        return alert('Office Asset Return Request Forwarded to Your Branch Officer')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    } 
    // For Individual Assets: They go directly to store
    else if (showIndiAssets) {
      // Create a modified request object for direct store submission
      let userReqData = {
        uniqueReqId: uniqueReqId,
        req_type: 'IndAsset_Rtrn_Str_Direct',
        req_creator_id: id,
        req_creator_details: `${nameStringFn(getSingleuser?.[id])}-${user_current_office}-${designation[user_current_office]}`,
        req_store: selectedStore,
        assets_requested:[{ time_stamp: new Date(), actionNo:1, data:field }],
        curr_status: 'Pending',
        created_at: new Date(),
        curr_sent_by: id,
        curr_sent_to: StoreL1_id,
        curr_sent_to_string: `${nameStringFn(getSingleuser?.[StoreL1_id])}-${selectedStore}-${getSingleuser?.[StoreL1_id]?.designation?.[selectedStore] || 'Unknown'}`,
        curr_sent_to_tag: 'ureq_retrn_ind_store_created',
        flow_users: [id],
        req_data: [{
          sent_to_tag: "ureq_retrn_ind_store_created",
          Text: remark,
          sent_by: { 
            id: id, 
            name: getSingleuser?.[id]?.name, 
            office: user_current_office, 
            designation: designation[user_current_office]
          },
          sent_to: {
            id: StoreL1_id,
            name: getSingleuser?.[StoreL1_id]?.name,
            office: selectedStore,
            designation: getSingleuser?.[StoreL1_id]?.designation?.[selectedStore] || 'Unknown'
          },
          action: 'New Individual Asset Return Request Created Directly to Store',
          time_stamp: new Date(),
        }],
        opened: false
      };

      // Here you would implement the API call to submit the return request to store
      try {
        await addNewRequest(userReqData)
        setContent('')
        navigate('/management/assets/myrequests')
        return alert('Individual Asset Return Request Submitted Directly to Store')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    }
  };

  // Generate summary data from selected assets
  const assetSummary = useMemo(() => {
    const summary = {};
    
    if (selectedAssets && selectedAssets.length > 0) {
      selectedAssets?.forEach(asset => {
        if (summary[asset.name]) {
          summary[asset.name].count += 1;
          summary[asset.name].assets.push(asset);
        } else {
          summary[asset.name] = {
            count: 1,
            assets: [asset]
          };
        }
      });
    }
    
    return Object.entries(summary).map(([name, data]) => ({
      name,
      count: data.count,
      assets: data.assets
    }));
  }, [selectedAssets]);

  // Set headings and filter props based on asset type
  const headerText = showIndiAssets ? "Select Individual Assets to Return" : "Select Office Assets to Return";
  

  return (
    <Container>
      <FilteredAssetReqFetcher filters={filters} onDataFetched={setAllData}/>
      {!showOfficeAssets && !showIndiAssets && (
        <HeadingWrap>
          <Span>Return Assets Available With by User</Span>
        </HeadingWrap>
      )}
      
      {!showOfficeAssets && !showIndiAssets && (
        <ButtonsContainer>
          <BigButton onClick={handleReturnOfficeAssets}>
            Return Office Assets
          </BigButton>
          <BigButton onClick={handleReturnIndividualAssets}>
            Return Individual Assets
          </BigButton>
        </ButtonsContainer>
      )}

      {(showOfficeAssets || showIndiAssets) && (
        <BackButtonWrapper>
          <BackButton onClick={handleBack}>
            <ArrowLeftIcon />
            <span style={{ marginLeft: '8px' }}>Back to Options</span>
          </BackButton>
        </BackButtonWrapper>
      )}
      
      {(showOfficeAssets || showIndiAssets) && (
        <>
          <HeadingWrap>
            <Span>{headerText}</Span>
          </HeadingWrap>
          
          <StoreSelectionContainer>
            <FormControl fullWidth>
              <InputLabel id="store-select-label">Select Store</InputLabel>
              <Select
                labelId="store-select-label"
                id="store-select"
                value={selectedStore}
                label="Select Store"
                onChange={handleStoreChange}
              >
                {stores.map((store, index) => (
                  <MenuItem key={index} value={store}>{store}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </StoreSelectionContainer>
          
          {selectedStore && (
            <UnivMyAssetComp 
              columnFilter={["OEM/ORG Tag", "OEM/Brand", "Model", "Store", "Detail"]}
              checkbox={true}
              selectedOptions={selectedAssets}
              setSelectedOptions={setSelectedAssets}
              selectAll={true}
              filterProps={{ 
                alloc_user: [id],
                alloc_ofc: [user_current_office],
                indi_issue: showIndiAssets ? 'true' : 'false',
                cur_store: [selectedStore],
              }}
            />
          )}

          {selectedStore && selectedAssets.length > 0 && (
            <SummaryContainer>
              <SummaryHeader>Selected Assets Summary</SummaryHeader>
              <StyledTableContainer component={Paper}>
                <Table aria-label="selected assets summary table">
                  <StyledTableHead>
                    <TableRow>
                      <TableCell>Asset Type</TableCell>
                      <TableCell align="center">Quantity</TableCell>
                      <TableCell>Asset Tags</TableCell>
                    </TableRow>
                  </StyledTableHead>
                  <TableBody>
                    {assetSummary.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell align="center">{item.count}</TableCell>
                        <TableCell>
                          <ChipContainer>
                            {item.assets.map((asset, i) => (
                              <Chip
                                key={i}
                                label={asset.oem_tag + (asset.org_tag ? `/${asset.org_tag}` : '')}
                                color="primary"
                                variant="outlined"
                                size="small"
                              />
                            ))}
                          </ChipContainer>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </StyledTableContainer>

              <RemarkContainer>
                <TextField
                  label="Remarks for Asset Return"
                  placeholder="Please provide details about why you are returning these assets"
                  multiline
                  rows={4}
                  value={remark}
                  onChange={handleRemarkChange}
                  fullWidth
                  required
                />
              </RemarkContainer>

              <SubmitButtonContainer>
                <SubmitButton onClick={handleSubmitToBo}>
                  Submit Assets to BO
                </SubmitButton>
                <SubmitStoreButton onClick={handleSubmitToStore}>
                  {showOfficeAssets ? 'Return Office Assets to Store via BO' : 'Return Individual Assets Directly to Store'}
                </SubmitStoreButton>
              </SubmitButtonContainer>
            </SummaryContainer>
          )}
        </>
      )}
    </Container>
  );
};

export default UserAssetReturnReq; 